import styles from "./style.module.scss";

interface CustomToastProps {
  title: string;
  description: string;
  icon: string;
  color: string;
}

const CustomToast = ({ title, description, icon, color }: CustomToastProps) => {
  return (
    <div className={styles.notificationContainer}>
      <div className={styles.infoContainer}>
        <div className={styles.titleContainer}>
          <img src={icon} alt="battery" />
          <div className={styles.title} style={{ color }}>
            {title}
          </div>
        </div>
        <div className={styles.notificationDescription}>{description}</div>
      </div>
    </div>
  );
};

export default CustomToast;
